import type { Theme } from '@mui/material';

export const styles = {
  header: (theme: Theme) => ({
    pb: 1.5,
    borderBottom: `1px solid ${theme.colors.neutral[100]}`,
  }),

  body: {
    position: 'relative',
    height: '21rem',
    width: '100%',
    mt: 7,
    overflow: 'visible',

    '> *': {
      bottom: '3rem',
    },
  },

  chart: (theme: Theme) => ({
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,

    [theme.breakpoints.up('md')]: {
      left: '4rem',
    },

    '> *': {
      height: '100%',
    },
  }),

  barGroup: (theme: Theme) => ({
    height: '100%',
    borderRight: `1px dashed ${theme.colors.neutral[200]}`,
    position: 'relative',
    overflow: 'visible',

    '&:last-of-type': {
      border: 'none',
    },
  }),

  labelX: (isLatest: boolean) => (theme: Theme) => ({
    color: theme.colors.neutral[600],
    fontWeight: isLatest ? 800 : 600,
    fontSize: isLatest ? 16 : 14,
    width: '100%',
    pt: '1.5rem',
  }),

  latestMarker: (theme: Theme) => ({
    position: 'absolute',
    bottom: '-0.1875rem',
    left: '-0.0625rem',
    width: '100%',
    height: '0.25rem',
    borderRadius: '0.125rem',
    bgcolor: theme.colors.secondary[400],
  }),
};
